import {PURCHASE_ORDER_DETAIL, PURCHASE_ORDER_LIST} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const ProcurementRoutes: IAppRoutes = {
  link: PURCHASE_ORDER_LIST,
  childrens: [
    {
      link: PURCHASE_ORDER_LIST,
      element: guard(() => import('@modules/procurement/PurchaseOrder'), [PURCHASE_ORDER_LIST]),
    },
    {
      link: PURCHASE_ORDER_DETAIL({id: ':id'}),
      element: guard(() => import('@modules/procurement/PurchaseOrder/Detail'), [PURCHASE_ORDER_LIST]),
    },
  ],
}
